import { render, staticRenderFns } from "./StoryVersionCard.vue?vue&type=template&id=90a755fe&"
import script from "./StoryVersionCard.vue?vue&type=script&lang=js&"
export * from "./StoryVersionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports